import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {appContext} from '../../../../../app.context';

class DettaglioLineePRModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    'store',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack'
  ];

  private close: any;
  private settings: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: any,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService
  ) {

    this.settings = $scope.$parent.$resolve.settings;
    /* tslint:disable:no-string-literal */
    // <editor-fold desc='initialization'>
    $scope.RiferimentoNumeroLineaType = new RegExp('^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])$'); // 1-9999
    $scope.String1000LatinType = new RegExp('^[\u0000-\u00FF]{1,1000}$');
    $scope.TipoCessionePrestazioneType = {
      '': '',
      'SC': 'Sconto',
      'PR': 'Premio',
      'AB': 'Abbuono',
      'AC': 'Spesa accessoria'
    };
    $scope.RitenutaType = {
      '': '',
      'SI': 'SI = Cessione / Prestazione soggetta a ritenuta'
    };
    $scope.NaturaType = {
      '': '',
      'N1': 'N1 - Escluse ex. art. 15 del D.P.R. 633/1972',
      'N2.1': 'N2.1 - Non soggette ad IVA ai sensi degli artt. da 7 a 7-septies del DPR 633/72',
      'N2.2': 'N2.2 - Non soggette - altri casi',
      'N3.1': 'N3.1 - Non Imponibili - esportazioni',
      'N3.2': 'N3.2 - Non Imponibili - cessioni intracomunitarie',
      'N3.3': 'N3.3 - Non Imponibili - cessioni verso San Marino',
      'N3.4': 'N3.4 - Non Imponibili - operazioni assimilate alle cessioni all\'esportazione',
      'N3.5': 'N3.5 - Non Imponibili - a seguito di dichiarazioni d\'intento',
      'N3.6': 'N3.6 - Non Imponibili - altre operazioni che non concorrono alla formazione del plafond',
      'N4': 'N4 - Esenti',
      'N5': 'N5 - Regime del margine',
      'N6.1': 'N6.1 - Inversione contabile - cessione di rottami e altri materiali di recupero',
      'N6.2': 'N6.2 - Inversione contabile - cessione di oro e argento ai sensi della legge 7/2000 nonché di oreficeria usata ad OPO',
      'N6.3': 'N6.3 - Inversione contabile - subappalto nel settore edile',
      'N6.4': 'N6.4 - Inversione contabile - cessione di fabbricati',
      'N6.5': 'N6.5 - Inversione contabile - cessione di telefoni cellulari',
      'N6.6': 'N6.6 - Inversione contabile - cessione di prodotti elettronici',
      'N6.7': 'N6.7 - Inversione contabile - prestazioni comparto edile e settori connessi',
      'N6.8': 'N6.8 - Inversione contabile - operazioni settore energetico',
      'N6.9': 'N6.9 - Inversione contabile - altri casi',
      'N7': 'N7 - IVA assolta in altro stato UE (vendite a distanza ex art. 40 commi 3 e 4 e art. 41 comma 1 lett. b, DL 331/93; prestazione di servizi di telecomunicazioni, tele-radiodiffusione ed elettronici ex art. 7-sexies lett. f, g, DPR 633/72 e art. 74-sexies, DPR 633/72)'
    };
    $scope.TipoScontoMaggiorazioneType = {
      'SC': 'SC = Sconto',
      'MG': 'MG = Maggiorazione'
    };
    let CodiceArticoloItem = {
      'CodiceTipo': '',
      'CodiceValore': ''
    };
    let ScontoMaggiorazioneItem = {
      'Tipo': '',
      'Percentuale': '0.00',
      'Importo': '0.00'
    };
    let AltriDatiGestionaliItem = {
      'TipoDato': '',
      'RiferimentoTesto': '',
      'RiferimentoNumero': '0.00',
      'RiferimentoData': ''
    };
    $rootScope.formsubmitted = false;
    // </editor-fold>

    this.settings.item.DataInizioPeriodo = this.settings.item.DataInizioPeriodo ? $rootScope.formatDateValue(this.settings.item.DataInizioPeriodo) : null;
    this.settings.item.DataFinePeriodo = this.settings.item.DataFinePeriodo ? $rootScope.formatDateValue(this.settings.item.DataFinePeriodo) : null;
    if (this.settings.item.AltriDatiGestionali !== undefined) {
      for (let i = 0; i < this.settings.item.AltriDatiGestionali.length; i++) {
        this.settings.item.AltriDatiGestionali[i].RiferimentoData = $rootScope.formatDateValue(this.settings.item.AltriDatiGestionali[i].RiferimentoData);
      }
    }

    $scope.item = this.settings.item;
    $scope.fatturaElettronicaBodyItemIndex = this.settings.fatturaElettronicaBodyItemIndex;
    $scope.CodiceArticoloIsIncluded = ($scope.item.CodiceArticolo !== undefined && $scope.item.CodiceArticolo.length > 0 ? true : false);
    $scope.addCodiceArticolo = () => {
      if ($scope.item.CodiceArticolo === undefined) {
        $scope.item.CodiceArticolo = [];
      }
      $scope.item.CodiceArticolo.push(jQuery.extend(true, {}, CodiceArticoloItem));
      $scope.CodiceArticoloIsIncluded = true;
    };
    $scope.removeCodiceArticolo = (CodiceArticoloItemIndex) => {

      if ($scope.item.CodiceArticolo.length - 1 === 0) {
        $scope.CodiceArticoloIsIncluded = false;
      }

      $timeout(() => {
        $scope.item.CodiceArticolo.splice(CodiceArticoloItemIndex, 1);
      }, 1);
    };
    $scope.ScontoMaggiorazioneIsIncluded = ($scope.item.ScontoMaggiorazione !== undefined && $scope.item.ScontoMaggiorazione.length > 0 ? true : false);
    $scope.addScontoMaggiorazione = () => {
      if ($scope.item.ScontoMaggiorazione === undefined) {
        $scope.item.ScontoMaggiorazione = [];
      }
      $scope.item.ScontoMaggiorazione.push(jQuery.extend(true, {}, ScontoMaggiorazioneItem));
      $scope.ScontoMaggiorazioneIsIncluded = true;
    };
    $scope.removeScontoMaggiorazione = (scontoMaggiorazioneItemIndex) => {
      if ($scope.item.ScontoMaggiorazione.length - 1 === 0) {
        $scope.ScontoMaggiorazioneIsIncluded = false;
      }

      $timeout(() => {
        $scope.item.ScontoMaggiorazione.splice(scontoMaggiorazioneItemIndex, 1);
      }, 1);
    };
    $scope.AltriDatiGestionaliIsIncluded = ($scope.item.AltriDatiGestionali !== undefined && $scope.item.AltriDatiGestionali.length > 0 ? true : false);
    $scope.addAltriDatiGestionali = () => {
      if ($scope.item.AltriDatiGestionali === undefined) {
        $scope.item.AltriDatiGestionali = [];
      }
      $scope.item.AltriDatiGestionali.push(jQuery.extend(true, {}, AltriDatiGestionaliItem));
      $scope.AltriDatiGestionaliIsIncluded = true;
    };
    $scope.removeAltriDatiGestionali = (AltriDatiGestionaliItemIndex) => {
      if ($scope.item.AltriDatiGestionali.length - 1 === 0) {
        $scope.AltriDatiGestionaliIsIncluded = false;
      }

      $timeout(() => {
        $scope.item.AltriDatiGestionali.splice(AltriDatiGestionaliItemIndex, 1);
      }, 1);
    };
    $scope.ok = () => {

      this.close({$value: $scope.item});
    };
    $scope.cancel = () => {
      this.close();
    };
    // <editor-fold desc='DatePicker'>
    $scope.calendar2 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar2.opened[which] = [];
        $scope.calendar2.opened[which][index1] = [];
        $scope.calendar2.opened[which][index1][index2] = true;
      }
    };
    $scope.autoOpenCalendar2 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }

        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar2.opened[which] = [];
        $scope.calendar2.opened[which][index1] = [];
        $scope.calendar2.opened[which][index1][index2] = true;
      }
    };
    $scope.calendar3 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2, index3) => {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar3.opened[which] = [];
        $scope.calendar3.opened[which][index1] = [];
        $scope.calendar3.opened[which][index1][index2] = [];
        $scope.calendar3.opened[which][index1][index2][index3] = true;
      }
    };
    $scope.autoOpenCalendar3 = {
      opened: {},
      dateFormat: 'dd/MM/yyyy',
      dateOptions: {},
      open: ($event, which, index1, index2, index3) => {

        if (appContext.userBrowser['isIE']) {
          return;
        }

        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendar3.opened[which] = [];
        $scope.calendar3.opened[which][index1] = [];
        $scope.calendar3.opened[which][index1][index2] = [];
        $scope.calendar3.opened[which][index1][index2][index3] = true;
      }
    };
    // </editor-fold>
  }
}

export const DettaglioLineePRModalComponent: ng.IComponentOptions = {
  template: require('./dettaglio-linee-pr-modal.html'),
  controller: DettaglioLineePRModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/dettaglio-linee-pr-modal/dettaglio-linee-pr-modal.ts